import { Role } from "../user-profile/role";

export class User {
    EimasId: string;
    /** PUID */
    Code: string;
    Email: string;
    Fullname: string;
    IsActive: boolean;
    Role?: Role;

    static mapFromJSON(json) {
        const u = new User();

        u.EimasId = json.eimasId;
        u.Code = json.code;
        u.Email = json.email;
        u.Fullname = json.fullname;
        u.IsActive = json.isActive;
        u.Role = json.role;

        if (json.role) {
            u.Role = Role.mapFromJSON(json.role);
        }
        return u;
    }
}
